import HttpFactory from "~/repository/factory";
import { ENDPOINTS } from "~/repository/endpoints";
import type {
  TeacherRetentionResponse,
  UserStatisticsResponse,
} from "~/types/admin/profiles";

class AdminProfilesStatisticsModule extends HttpFactory {
  async getUserStatistics(): Promise<UserStatisticsResponse> {
    return await this.get<UserStatisticsResponse>(
      `${ENDPOINTS.ADMIN.PROFILES.USER_STATISTICS}`,
    );
  }

  async getTeacherRetentionStatistics(): Promise<TeacherRetentionResponse> {
    return await this.get<TeacherRetentionResponse>(
      `${ENDPOINTS.ADMIN.PROFILES.TEACHER_RETENTION_STATISTICS}`,
    );
  }
}

export { AdminProfilesStatisticsModule };
